"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../actions");
const reducers_1 = require("../../reducers");
const LoadingIndicator_1 = require("./LoadingIndicator");
const src_1 = require("@rover/ts-bootstrap/dist/src");
class NewCampaignPopover extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            contentState: 'campaign-types',
            isEditingCampaignName: false,
            newCampaignName: '',
        };
        this.handleOpenClose = this.handleOpenClose.bind(this);
        this.getRightButtonCallback = this.getRightButtonCallback.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        const { isNewCampaignPopoverOpen } = this.props;
        if (isNewCampaignPopoverOpen && !nextProps.isNewCampaignPopoverOpen) {
            this.setState({
                contentState: 'campaign-types',
                newCampaignName: '',
                isEditingCampaignName: false,
            });
        }
    }
    getLeftButtonCallback() {
        const { contentState } = this.state;
        switch (contentState) {
            case 'campaign-types':
                return () => this.handleOpenClose();
            case 'name-campaign':
                return () => this.setState({
                    contentState: 'campaign-types',
                    isEditingCampaignName: false,
                });
            case 'loading':
            default:
                return () => null;
        }
    }
    getRightButtonCallback() {
        const { newCampaignTrigger } = this.state;
        return () => this.setState({
            contentState: 'loading',
        }, () => this.props.onCreate(this.state.newCampaignName, newCampaignTrigger));
    }
    getLeftButton() {
        const { contentState } = this.state;
        switch (contentState) {
            case 'campaign-types':
                return 'Cancel';
            case 'name-campaign':
                return 'Back';
            case 'loading':
            default:
                return '';
        }
    }
    getRightButton() {
        const { contentState, newCampaignName } = this.state;
        if (!newCampaignName) {
            return;
        }
        switch (contentState) {
            case 'campaign-types':
                return '';
            case 'name-campaign':
                return 'Save';
            case 'loading':
            default:
                return '';
        }
    }
    getTitle() {
        const { contentState, newCampaignTrigger } = this.state;
        switch (contentState) {
            case 'campaign-types':
                return 'New Campaign Type';
            case 'name-campaign':
                return this.getReadableCampaignName(newCampaignTrigger);
            case 'loading':
            default:
                return '';
        }
    }
    getCampaignTriggerSubtext(trigger) {
        switch (trigger.__typename) {
            case 'CampaignScheduledTrigger':
                return 'Delivered at a given date and time';
            case 'CampaignAutomatedTrigger':
                return 'Delivered when a specific event occurs';
            case 'CampaignAPITrigger':
                return 'Delivered by an API call';
            case 'InterstitialCampaignTrigger':
                return 'Presented when the app is opened';
            case 'URLCampaignTrigger':
                return 'Presented manually through other channels';
        }
    }
    handleOpenClose() {
        const { closeNewCampaignPopover, isNewCampaignPopoverOpen, openNewCampaignPopover } = this.props;
        if (isNewCampaignPopoverOpen) {
            this.setState({ contentState: 'campaign-types' }, closeNewCampaignPopover);
        }
        else {
            openNewCampaignPopover();
        }
    }
    getCampaignIcon(trigger) {
        const { media } = this.props;
        switch (trigger.__typename) {
            case 'CampaignScheduledTrigger':
                return React.createElement(src_1.CalendarIcon, { fill: src_1.steel, height: "20", width: "20", viewBox: "0 0 24 24" });
            case 'CampaignAutomatedTrigger':
                return React.createElement(src_1.ZapIcon, { fill: src_1.steel, height: "20", width: "20", viewBox: "0 0 24 24" });
            case 'CampaignAPITrigger':
                return React.createElement(src_1.HashtagIcon, { fill: src_1.steel, height: "24", width: "24", viewBox: "0 0 20 20" });
            case 'InterstitialCampaignTrigger':
                return React.createElement(src_1.PhoneIcon, { fill: src_1.steel, height: "20", width: "20", viewBox: "0 0 24 24" });
            case 'URLCampaignTrigger':
                return React.createElement(src_1.LinkIcon, { fill: src_1.steel, height: "20", width: "20", viewBox: "0 0 24 24" });
        }
    }
    getReadableCampaignName(trigger) {
        switch (trigger.__typename) {
            case 'CampaignScheduledTrigger':
                return 'Scheduled Notification';
            case 'CampaignAutomatedTrigger':
                return 'Automated Notification';
            case 'CampaignAPITrigger':
                return 'API Notification';
            case 'InterstitialCampaignTrigger':
                return 'Interstitial Experience';
            case 'URLCampaignTrigger':
                return 'Web/Social Experience';
        }
    }
    renderCampaignIcon(trigger) {
        const style = {
            height: 40,
            width: 40,
            borderRadius: 40,
            border: 'none',
            background: src_1.cloud,
            marginRight: 16,
            flex: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        };
        return React.createElement("div", { style: style }, this.getCampaignIcon(trigger));
    }
    renderCampaignListElement(trigger) {
        const { media } = this.props;
        return (React.createElement("div", { id: `newCampaign-${trigger.__typename}`, style: {
                width: '100%',
                padding: media === 'Mobile' ? '0 24px' : '0 16px',
            }, onMouseOver: () => (document.getElementById(`newCampaign-${trigger.__typename}`).style.backgroundColor = src_1.beige), onMouseOut: () => (document.getElementById(`newCampaign-${trigger.__typename}`).style.backgroundColor = src_1.white), onClick: () => this.setState({
                contentState: 'name-campaign',
                newCampaignTrigger: trigger,
            }) },
            React.createElement("div", { style: {
                    width: '100%',
                    height: media === 'Mobile' ? 96 : 80,
                    borderBottom: (trigger.__typename !== 'CampaignAPITrigger' || media === 'Mobile') && `1px solid ${src_1.cloud}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    boxSizing: 'border-box',
                } },
                this.renderCampaignIcon(trigger),
                React.createElement("div", { style: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    } },
                    React.createElement(src_1.Text, { size: "medium", text: this.getReadableCampaignName(trigger) }),
                    React.createElement(src_1.Text, { size: "small", label: true, text: this.getCampaignTriggerSubtext(trigger), textStyle: {
                            display: 'block',
                            width: 270,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            overflowWrap: 'break-word',
                            textOverflow: 'ellipsis',
                        } })),
                React.createElement(src_1.ChevronRightIcon, { style: {
                        transform: `scale(${5 / 6})`,
                        flex: 'none',
                    }, fill: src_1.titanium }))));
    }
    getNavbarLeftElem() {
        const { media } = this.props;
        const { contentState } = this.state;
        if (contentState === 'name-campaign') {
            return (React.createElement("div", { style: {
                    display: 'flex',
                    marginLeft: media === 'Mobile' ? 16 : -8,
                }, onClick: this.getLeftButtonCallback() },
                React.createElement(src_1.ChevronLeftIcon, { fill: "#818181" }),
                React.createElement(src_1.Button, { text: "Back", type: "disabled", style: {
                        innerStyle: {
                            fontSize: 17,
                            padding: 0,
                            color: src_1.steel,
                        },
                        outerStyle: {
                            height: 24,
                            display: 'flex',
                            alignItems: 'center',
                            background: 'none',
                        },
                    } })));
        }
        return null;
    }
    renderContent() {
        const { onCreate, media } = this.props;
        const { contentState, isEditingCampaignName, newCampaignName, newCampaignTrigger } = this.state;
        return (React.createElement("div", null,
            contentState === 'campaign-types' && (React.createElement("div", null,
                this.renderCampaignListElement({
                    __typename: 'CampaignScheduledTrigger',
                }),
                this.renderCampaignListElement({
                    __typename: 'CampaignAutomatedTrigger',
                }),
                this.renderCampaignListElement({
                    __typename: 'CampaignAPITrigger',
                }))),
            contentState === 'name-campaign' && (React.createElement("div", { style: {
                    padding: media === 'Mobile' ? '0 24px' : '0 16px',
                } },
                React.createElement("div", { style: {
                        height: media === 'Mobile' ? 71 : 56,
                        borderBottom: media === 'Mobile' ? `1px solid ${src_1.titanium}` : undefined,
                        display: 'flex',
                        alignItems: 'center',
                    }, onClick: () => this.setState({ isEditingCampaignName: true }) },
                    React.createElement(src_1.Text, { text: newCampaignName, textStyle: { width: 350 }, id: "new-campaigns-popover-name", contentEditable: isEditingCampaignName, onInputChange: (newCampaignName) => this.setState({ newCampaignName }), handleChange: (str) => {
                            if (str.length !== 0) {
                                this.setState({
                                    contentState: 'loading',
                                }, () => onCreate(str, newCampaignTrigger));
                            }
                            else {
                                this.setState({
                                    isEditingCampaignName: false,
                                });
                            }
                        }, handleBlurChange: (newCampaignName) => {
                            this.setState({
                                newCampaignName,
                                isEditingCampaignName: false,
                            });
                        }, onBlurChange: true, placeholder: true, placeholderText: "Enter campaign name", size: "medium" })))),
            contentState === 'loading' && (React.createElement("div", { style: {
                    height: media === 'Mobile' ? '100%' : 56,
                    padding: 16,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                React.createElement(LoadingIndicator_1.default, null)))));
    }
    render() {
        const { media, onCreate, isNewCampaignPopoverOpen, isNewCampaignPopoverClosing } = this.props;
        const { contentState, newCampaignName, newCampaignTrigger } = this.state;
        const popoverProps = {
            placement: media === 'Desktop' ? 'bottom-start' : 'bottom-end',
            toggle: this.handleOpenClose,
            navBarProperties: {
                title: this.getTitle(),
                buttonRight: this.getRightButton(),
                buttonLeft: this.getLeftButton(),
                buttonLeftCallback: this.getLeftButtonCallback(),
                buttonRightCallback: this.getRightButtonCallback(),
                customLeftElem: this.getNavbarLeftElem(),
                id: 'navBarId',
                style: {
                    containerStyle: {
                        borderRadius: '3px 3px 0px 0px',
                        padding: 16,
                    },
                    buttonLeftStyle: {
                        outerStyle: {
                            height: 17,
                        },
                    },
                    buttonRightStyle: {
                        outerStyle: {
                            marginRight: 0,
                        },
                    },
                },
            },
            arrowColors: {
                primary: src_1.cloud,
                secondary: src_1.white,
                border: src_1.titanium,
            },
        };
        const targetId = 'desktop-new-campaign-button';
        const Fragment = React.Fragment;
        return (React.createElement(Fragment, null,
            React.createElement(src_1.PopoverContainer, { id: "desktop-new-campaign-button", popoverProps: popoverProps, onClick: this.handleOpenClose, targetParent: "root", showPopover: isNewCampaignPopoverOpen && media !== 'Mobile' },
                media === 'Desktop' ? (React.createElement(src_1.Button, { text: "New Campaign", type: "primary", size: "small" })) : (React.createElement(src_1.PlusSquareIcon, { fill: src_1.turquoise })),
                React.createElement("div", { style: {
                        display: 'flex',
                        height: 'auto',
                        width: 384,
                        flexDirection: 'column',
                    } }, this.renderContent())),
            isNewCampaignPopoverOpen && media === 'Mobile' && (React.createElement("div", { id: "sendTestId", style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    zIndex: 2,
                    position: 'absolute',
                    background: src_1.white,
                    top: 0,
                    left: 0,
                    animation: `${isNewCampaignPopoverClosing ? 'close' : 'open'} 300ms ease`,
                    overflowY: 'scroll',
                } },
                React.createElement("div", { style: {
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    } },
                    React.createElement(src_1.NavBar, { buttonRight: this.getRightButton(), buttonLeft: this.getLeftButton(), buttonRightCallback: this.getRightButtonCallback(), buttonLeftCallback: this.getLeftButtonCallback(), style: {
                            buttonLeftStyle: {
                                outerStyle: {
                                    marginLeft: 24,
                                },
                            },
                            buttonRightStyle: {
                                outerStyle: {
                                    marginRight: 24,
                                },
                            },
                        }, title: this.getTitle(), customLeftElem: this.getNavbarLeftElem() }),
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            marginBottom: 24,
                        } }, this.renderContent()))))));
    }
}
const mapDispatchToProps = (dispatch, ownProps) => {
    const { media } = ownProps;
    return {
        closeNewCampaignPopover: () => {
            if (media === 'Mobile') {
                dispatch({ type: 'START_CLOSING_NEW_CAMPAIGN_POPOVER' });
                setTimeout(() => dispatch(actions_1.closeNewCampaignPopover()), 295);
            }
            else {
                dispatch(actions_1.closeNewCampaignPopover());
            }
        },
        openNewCampaignPopover: () => dispatch(actions_1.openNewCampaignPopover()),
    };
};
const mapStateToProps = (state) => ({
    isNewCampaignPopoverClosing: reducers_1.getIsNewCampaignPopoverClosing(state),
    isNewCampaignPopoverOpen: reducers_1.getIsNewCampaignPopoverOpen(state),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NewCampaignPopover);
